export enum CommentType {
  company = 10,
  course = 20,
  question = 30,
  teacher = 40
}
